import { render, staticRenderFns } from "./inventoryList.vue?vue&type=template&id=5e5ca054&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"
import style0 from "./inventoryList.vue?vue&type=style&index=0&id=5e5ca054&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ca054",
  null
  
)

export default component.exports